module.exports = __webpack_public_path__ + "static/media/logo.ff733367.svg";